import { SvgIcon } from "@mui/material";

const SvgIconComponent = ({ children, color, padding = ".3rem", size }) => {
  return (
    <SvgIcon sx={{ color, padding }} fontSize={size}>
      {children}
    </SvgIcon>
  );
}

export default SvgIconComponent;